
export const text = [
    {
        type: "start",
        screenLengthPos: .5
    },
    {
        text: "There's only one lead smelter in Florida.",
        screenLengthPos: 1.5,
    },
    {
        text: "It's located in east Tampa.",
        screenLengthPos: 2.5,
    },
    {
        text: "Inside Gopher Resource, lead is extracted from batteries.",
        screenLengthPos: 3.5,
    },
    {
        text: "It is then melted in furnaces.",
        screenLengthPos: 4.5,
    },
    {
        text: "More than 300 people work there. Many toil in extreme heat.",
        screenLengthPos: 5.5,
    },
    {
        text: "They wear respirators because of the dangers.",
        screenLengthPos: 6.5
    },
    {
        text: "The dangers start with the dust.",
        screenLengthPos: 7.5
    },
    {
        text: "It's full of lead.",
        screenLengthPos: 8,
    },
    {
        text: "Falling like an avalanche.",
        screenLengthPos: 9,
    },
    {
        text: "Swirling like a snow flurry.",
        screenLengthPos: 13.5,
    },
    {
        text: "Exploding like a dusty bomb.",
        screenLengthPos: 18.5,
    },
    {
        text: "Hundreds of workers have been exposed to high amounts of lead.",
        screenLengthPos: 22.5,
    },
    {
        text: "Workers are issued respirators that don't always protect them.",
        screenLengthPos: 23.5,
    },

    {
        text: "Here are 155 air samples taken from monitors attached to workers in the furnace department from 2013 to 2019.",
        screenLengthPos: 24.5
    },
    {
        text: "More than a quarter of all samples reported higher concentrations of lead in the air than the <span class='resp-muc-highlight'>standard respirators</span> in use at Gopher could guard against.",
        screenLengthPos: 25.5
    },
    {
        text: "Some workers stay around these toxic levels of lead for years.",
        screenLengthPos: 26.5
    },
    {
        text: "Consider what happened to Prospere Dumeus. He worked at the plant for over three decades.",
        screenLengthPos: 27.5
    },
    {
        text: "His blood was tested more than 180 times. Every one of his blood-lead results surpassed the threshold the Centers for Disease Control and Prevention considers <span class='cdc-highlight'>elevated</span>.",
        screenLengthPos: 28.5
    },
    {
        text: "His levels were so high for so long, doctors believe lead exposure contributed to his health problems.",
        screenLengthPos: 29.5
    },
    {
        text: "Dumeus suffered from heart conditions and hypertension. In 2017 he underwent his final heart surgery.",
        screenLengthPos: 30.5
    },
    {
        text: "He died two years later of coronary artery and kidney disease at the age of 56.",
        screenLengthPos: 31.5
    },
    {
        text: "Don't miss the 18-month investigation.",
        screenLengthPos: 32.5
    },
    {
        text: "#Poisoned\n\nComing Thursday",
        type: "end",
        screenLengthPos: 33.5
    },

]